export const VideoOptions: Array<any> = [
    {
        length: 15,
        label: "Motion Graphics Video - 15 Seconds",
        scriptProvidedBy: "Script provided by Client",
        priceLabel_number: "S$2,100.00",
        priceLabel_type: "for 1 x 15-sec Motion Graphics Video",
        price: 2100,
        text: "Price includes 2D motion graphics, 1 x voice over, 1 x library music and upload for broadcast.",
        quantity: 1,
        creative_product_id: 1,
        checked: false,
        showMoreText: { 'sec': '15sec', 'numberOfImg': 5, 'workingDays': 7 }
    },
    {
        length: 15,
        label: "Motion Graphics Video - 15 Seconds",
        scriptProvidedBy: "Script provided by Mediacorp",
        priceLabel_number: "S$2,500.00",
        priceLabel_type: "for 1 x 15-sec Motion Graphics Video",
        price: 2500,
        text: "Price includes 2D motion graphics, 1 x voice over, 1 x library music and upload for broadcast.",
        quantity: 1,
        creative_product_id: 2,
        checked: false,
        showMoreText: { 'numberOfImg': 5, 'workingDays': 10 }
    },
    {
        length: 30,
        label: "Motion Graphics Video - 30 Seconds",
        scriptProvidedBy: "Script provided by Client",
        priceLabel_number: "S$3,200.00",
        priceLabel_type: "for 1 x 30-sec Simple Graphics Video",
        price: 3200,
        text: "Price includes 2D motion graphics, 1 x voice over, 1 x library music and upload for broadcast.",
        quantity: 1,
        creative_product_id: 3,
        checked: false,
        showMoreText: { 'sec': '30sec', 'numberOfImg': 10, 'workingDays': 12 }
    },
    {
        length: 30,
        label: "Motion Graphics Video - 30 Seconds",
        scriptProvidedBy: "Script provided by Mediacorp",
        priceLabel_number: "S$3,800.00",
        priceLabel_type: "for 1 x 30-sec Simple Graphics Video",
        price: 3800,
        text: "Price includes 2D motion graphics, 1 x voice over, 1 x library music and upload for broadcast.",
        quantity: 1,
        creative_product_id: 4,
        checked: false,
        showMoreText: { 'numberOfImg': 10, 'workingDays': 15 }
    }
];

export const SampleVideoOptions: any = {
    15: {
        time: "15 seconds",
        url: "https://player.videologygroup.com/admanager/demo/mediacorp/Tom_sTea15s.mp4"
    },
    30: {
        time: "30 seconds",
        url: "https://player.videologygroup.com/admanager/demo/mediacorp/SGTogetherTuasPowerdigital_EN30s.mp4"
    }
};

export const CreativeProductIdMap = {
    1: {
        type: '15-Sec Motion Graphics Video (Client Produced)',
        price: 2100
    },
    2: {
        type: '15-Sec Motion Graphics Video (Mediacorp Produced)',
        price: 2500
    },
    3: {
        type: '30-Sec Motion Graphics Video (Client Produced)',
        price: 3200
    },
    4: {
        type: '30-Sec Motion Graphics Video (Mediacorp Produced)',
        price: 3800
    }
}